<template>
  <div class="page">
    <div class="page-title">報告</div>
    <div class="page-box">
      <div v-for="(item, index) in list" :key="index">
        <div class="item-text" @click="onClicked(item.path)">
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          title: "年級銷售統計",
          path: "/report/course-sales-statistics",
        },
        {
          title: "學習表現冒險模式",
          path: "/report/adventure-mode-report",
        },
        {
          title: "學習表現作業",
          path: "/report/school-assignment-report",
        },
        {
          title: "推廣碼報告",
          path: "/report/promotion-code-report",
        },
      ],
    };
  },
  methods: {
    onClicked(path) {
      this.$router.push({ path: path });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-title{
  margin-bottom: 20px;
}
.page-box{
  background-color: #fff;
  padding: 20px;
}
.item-text{
      display: inline-block;
      color: #166EA5;
      cursor: pointer;
      font-size: 20px;
      border-bottom: 1px solid #166ea5;
      margin-bottom: 30px;
}
</style>